var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBillingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0001 4.81819H16.2728C16.9738 4.81819 17.5455 5.38992 17.5455 6.09092V13.7273C17.5455 14.4283 16.9738 15 16.2728 15H4.81826C4.11727 15 3.54553 14.4283 3.54553 13.7273V11.1818M1 3.54547H15M15 7.36363H17.5455M13.7273 11.1818H2.27273C1.57173 11.1818 1 10.6101 1 9.90909V2.27273C1 1.57173 1.57173 1 2.27273 1H13.7273C14.4283 1 15 1.57173 15 2.27273V9.90909C15 10.6101 14.4283 11.1818 13.7273 11.1818Z",
    stroke: "#7D8D98",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillingIcon);
export default __webpack_public_path__ + "static/media/billing-icon.7f1cd8e96a4bda1d7a585af4b35d6507.svg";
export { ForwardRef as ReactComponent };